import { useLocation, useFetcher, useParams } from 'react-router-dom';
import { styled } from 'styled-components';
import { Dialog, DialogActions } from 'components/ui';

const FormHelperText = styled.p`
  font-size: 14px;
  color: #1c2127;
  margin: 0;
`;

const FormHeaderText = styled(FormHelperText)`
  margin: 0 0 12px;
`;

const FormControl = styled.input`
  appearance: none;
  background: #fff;
  border: none;
  color: #1c2127;
  font-size: 14px;
  padding: 0;
  width: 100%;
  outline: none;
  font-weight: 700;

  /* Add quotes around the input value */
  content: '${(props) => props.value}';
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: none;
  padding: 0 15px;
  font-size: 14px;
  line-height: 1;
  font-weight: 500;
  height: 35px;
  cursor: pointer;
  box-shadow:
    inset 0 0 0 1px rgb(17 20 24 / 20%),
    0 1px 2px rgb(17 20 24 / 10%);
  background-color: '#f6f7f9';
  color: '#1c2127';

  &:hover {
    background-color: '#e8e9eb';
  }
`;

const AlertButton = styled(Button)`
  background-color: #d14e47;
  color: white;

  &:hover {
    background-color: #ab2e27;
  }
`;

/**
 * DeleteDashboard component
 *
 * @param {object} props -
 * @param {Function} props.onClose - The function to change the open state of the dialog
 * @param {object} props.dashboard - The dashboard object
 * @returns {JSX.Element} - The DeleteDashboard component
 */
export default function DeleteDashboard({ onClose, dashboard }) {
  const { Form } = useFetcher();
  const { pathname } = useLocation();
  const { orgKey } = useParams();
  const returnTo = pathname.includes(dashboard?.id) ? '..' : pathname;
  return dashboard ? (
    <Dialog
      name="Delete Dashboard"
      description="Delete the selected dashboard"
      open
      onOpenChange={onClose}
    >
      <Form
        onSubmit={onClose}
        method="delete"
        action={`/organization/${orgKey}/dashboard/${dashboard.id}/manage`}
      >
        <FormHeaderText>
          Are you sure you want to delete the following dashboard?
        </FormHeaderText>
        <FormControl
          // Prevents focus on the input field
          tabIndex={-1}
          name="name"
          defaultValue={dashboard.name}
          readOnly
        />
        <FormHelperText>{`In project "${dashboard.project}"`}</FormHelperText>
        <FormControl name="returnTo" defaultValue={returnTo} type="hidden" />
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <AlertButton type="submit">Delete</AlertButton>
        </DialogActions>
      </Form>
    </Dialog>
  ) : null;
}
